import "./auth-service-tools36.js";
import { shiftTimezone } from "./auth-service-tools574.js";

function dateStringParser(dateString, timezone) {
  if (dateString === null) {
    return null;
  }

  const date = shiftTimezone("add", new Date(dateString), timezone);

  if (Number.isNaN(date.getTime()) || !dateString) {
    return null;
  }

  return date;
}

export { dateStringParser };